import axios from "axios";
const axiosInstance = axios.create({
  baseURL: (window.clientConfig && window.clientConfig.serverUrl) ? window.clientConfig.serverUrl : "http://www.freepascal.org:8989"
});

export { axiosInstance };
